const integrationsCount = String(process.env.NEXT_PUBLIC_DESTINATIONS_COUNT);
const sourcesCount = String(process.env.NEXT_PUBLIC_SOURCES_COUNT);

export { integrationsCount, sourcesCount };
